/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Raw_Platypus_StabInputs */

const en_odd_raw_platypus_stab = /** @type {(inputs: Odd_Raw_Platypus_StabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sources found`)
};

const de_odd_raw_platypus_stab = /** @type {(inputs: Odd_Raw_Platypus_StabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Quellen gefunden`)
};

/**
* | output |
* | --- |
* | "No sources found" |
*
* @param {Odd_Raw_Platypus_StabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const odd_raw_platypus_stab = /** @type {((inputs?: Odd_Raw_Platypus_StabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Raw_Platypus_StabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_odd_raw_platypus_stab(inputs)
	return de_odd_raw_platypus_stab(inputs)
});